// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3t2mu","header":"ReportDetails_header__2Pvw7","title":"ReportDetails_title__25pEH","left":"ReportDetails_left__1uW7k"};